import React from 'react';
import useMedia from 'use-media';
import { Label } from '../atoms/label';
import { ModalOptionForm } from './modalOptionForm';
import { PullDownOptionForm } from './pullDownOptionForm';

export const RoomInputList = (props) => {
    const { state,
        flgList,
        roomList,
        roomTypeList,
        adultNumList,
        childNumList,
        responsiveFlg,
        onClickOpenRoomPopup,
        onChangeHumanNum,
        confirmFlg,
        generalFlg,
        roomTypeDisabled,
    } = props;

    const createRoomTypeList = (index) => {
        const selectedRoomCd = roomList[index].roomType;
        let dispRoomTypeList = roomTypeList.map(value => {
            if (selectedRoomCd && selectedRoomCd === value.id) {
                const newObj = {
                    id: value.id,
                    value: value.value,
                    roomCapacity: value.roomCapacity,
                    roomSelectMax: value.roomSelectMax,
                    disabled: false,
                }
                return newObj
            }
            return value;
        });
        return dispRoomTypeList
    }

    const getRooms = () => {
        const room = [];
        roomList.map((roomValue, roomIndex) => {
            room.push(
                <div key={"room" + roomIndex}>
                    <div className="userInputWrapper3">
                        <div><Label label={(roomIndex + 1) + "室目"} className="roomIndex" /></div>
                    </div>
                    {confirmFlg ?
                        <div className="reserveInputWrapper">
                            <Label
                                label={roomValue.machiLabel}
                                className={roomValue.machiLabel ? "machiRoomLabelRight" : "hiddenItem"}
                            />
                            <div className="userInput2">
                                <div className={"reserveInfo"}>
                                    <div className={"inputUserWrap"}>
                                        <div className="confirmContentsBorder firstContent">
                                            <Label
                                                label={"お部屋タイプ"}
                                                className="reserveInfoTitle"
                                            />
                                            <Label
                                                label={roomValue.roomTypeName}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                        <div className="confirmContentsBorder lastContent">
                                            <Label
                                                label={"ご利用人数"}
                                                className="reserveInfoTitle"
                                            />
                                            <div className='confirmContentsBlock'>
                                                {roomValue.menCnt != 0 ?
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={"大人(男性)"}
                                                            className="confirmContentLabel"
                                                        />
                                                        <Label
                                                            label={roomValue.menCnt + "人"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                    : null}
                                                {roomValue.womenCnt != 0 ?
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={"大人(女性)"}
                                                            className="confirmContentLabel"
                                                        />
                                                        <Label
                                                            label={roomValue.womenCnt + "人"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                    : null}
                                                {roomValue.childCnt != 0 ?
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={"小学生"}
                                                            className="confirmContentLabel"
                                                        />
                                                        <Label
                                                            label={roomValue.childCnt + "人"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                    : null}
                                                {roomValue.preschoolerCnt != 0 ?
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={"幼児(3歳～5歳)"}
                                                            className="confirmContentLabel"
                                                        />
                                                        <Label
                                                            label={roomValue.preschoolerCnt + "人"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                    : null}
                                                {roomValue.babyCnt != 0 ?
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={"乳児(0歳～2歳)"}
                                                            className="confirmContentLabel"
                                                        />
                                                        <Label
                                                            label={roomValue.babyCnt + "人"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                    : null}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="reserveInputWrapper">
                            <div className="userInput2">
                                <div className={"stayInfo"} style={styles.userInput}>
                                    <div className='roomTypeTitleWrapper'>
                                        <Label
                                            label="お部屋タイプ"
                                            className="modalLabel"
                                        />
                                        <Label
                                            label={roomValue.machiLabel}
                                            className={roomValue.machiLabel ? "machiRoomLabel" : "hiddenItem"}
                                        />
                                    </div>
                                    <ModalOptionForm
                                        divClass={generalFlg ? "hiddenItem" : responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                                        labelClassName="popupLabel"
                                        dateClass={(roomTypeDisabled ? "disabledClass " : "") + (flgList.errorRoomList && flgList.errorRoomList[roomIndex].errorRoomType ? "errorClass" : "")}
                                        id={"roomType" + roomIndex}
                                        onClick={() => onClickOpenRoomPopup(roomTypeList, roomIndex)}
                                        text={roomValue.roomTypeName ? roomValue.roomTypeName : "選択する" }
                                    />
                                    <Label
                                        label="ご利用人数"
                                        className="popupLabel"
                                    />
                                    <div>
                                        <div className='inputHunmanNumWrapper'>
                                            <PullDownOptionForm
                                                title={"大人(男性)"}
                                                labelClassName="inputHunmanNumLabel"
                                                id={"menCnt" + roomIndex}
                                                divClass="inputHunmanNum"
                                                selectClass={flgList.errorRoomList && flgList.errorRoomList[roomIndex].errorAdultNum ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                                data={adultNumList}
                                                onChange={() => onChangeHumanNum("menCnt", roomIndex)}
                                                state={roomValue.menCnt}
                                            />
                                            <Label
                                                label="人"
                                            />
                                        </div>
                                        <div className='inputHunmanNumWrapper'>
                                            <PullDownOptionForm
                                                title={"大人(女性)"}
                                                labelClassName="inputHunmanNumLabel"
                                                id={"womenCnt" + roomIndex}
                                                divClass="inputHunmanNum"
                                                selectClass={flgList.errorRoomList && flgList.errorRoomList[roomIndex].errorAdultNum ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                                data={adultNumList}
                                                onChange={() => onChangeHumanNum("womenCnt", roomIndex)}
                                                state={roomValue.womenCnt}
                                            />
                                            <Label
                                                label="人"
                                            />
                                        </div>
                                        <div className='inputHunmanNumWrapper'>
                                            <PullDownOptionForm
                                                title={"小学生"}
                                                labelClassName="inputHunmanNumLabel"
                                                id={"childCnt" + roomIndex}
                                                divClass="inputHunmanNum"
                                                selectClass={flgList.errorRoomList && flgList.errorRoomList[roomIndex].errorChildNum ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                                data={childNumList}
                                                onChange={() => onChangeHumanNum("childCnt", roomIndex)}
                                                state={roomValue.childCnt}
                                            />
                                            <Label
                                                label="人"
                                            />
                                        </div>
                                        <div className='inputHunmanNumWrapper'>
                                            <PullDownOptionForm
                                                title={"幼児(3歳～5歳)"}
                                                labelClassName="inputHunmanNumLabel"
                                                id={"preschoolerCnt" + roomIndex}
                                                divClass="inputHunmanNum"
                                                selectClass={flgList.errorRoomList && flgList.errorRoomList[roomIndex].errorChildNum ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                                data={childNumList}
                                                onChange={() => onChangeHumanNum("preschoolerCnt", roomIndex)}
                                                state={roomValue.preschoolerCnt}
                                            />
                                            <Label
                                                label="人"
                                            />
                                        </div>
                                        <div className='inputHunmanNumWrapper'>
                                            <PullDownOptionForm
                                                title={"乳児(0歳～2歳)"}
                                                labelClassName="inputHunmanNumLabel"
                                                id={"babyCnt" + roomIndex}
                                                divClass="inputHunmanNum"
                                                selectClass={flgList.errorRoomList && flgList.errorRoomList[roomIndex].errorChildNum ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                                data={childNumList}
                                                onChange={() => onChangeHumanNum("babyCnt", roomIndex)}
                                                state={roomValue.babyCnt}
                                            />
                                            <Label
                                                label="人"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            );
        })
        return room;
    }
    const rooms = getRooms();

    return (
        <>
            <div>{rooms}</div>
        </>
    );
}
const styles = {
    userInput: {
        display: "block",
        flexWrap: "wrap",
    }
}